export const convertStringToCsvContent = (data: string) => {
  const BOM = "\uFEFF";
  return new Blob([BOM + data], { type: "text/csv;charset=utf-8" });
};
